import { saveHref } from './src/utils/acquisition';

export const onRouteUpdate = ({ location }: { location: Location }) => {
  saveHref({ location });
};
